import { render, staticRenderFns } from "./ConfirmDeactive.vue?vue&type=template&id=6af84f8e&scoped=true&"
import script from "./ConfirmDeactive.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeactive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af84f8e",
  null
  
)

export default component.exports